import SectionHeading from '@/components/base/SectionHeading';
import { WEEKLY_EVENTS } from '@/mocks/schedule';

export default function WeeklyPlan() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50" aria-labelledby="weekly-heading">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <SectionHeading
              id="weekly-heading"
              eyebrow="This Week"
              title="本周活动安排"
              desc="答疑、分享、素材更新与节点提醒都会提前排进日程，按时间进入对应直播间即可。"
            />
            <div className="mt-6 rounded-lg bg-secondary-50 border border-secondary-200 p-5">
              <p className="text-sm text-secondary-900 leading-relaxed">
                <strong className="font-semibold">提醒：</strong>
                海选阶段的所有答疑直播均支持回放，错过直播可以在活动安排页查看回放入口。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ul className="flex flex-col divide-y divide-background-200 border-y border-background-200">
              {WEEKLY_EVENTS.map((ev) => (
                <li key={`${ev.date}-${ev.title}`} className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 py-5">
                  <div className="w-20 shrink-0">
                    <div className="font-heading text-xl font-bold text-foreground-950 leading-none">{ev.date}</div>
                    <div className="text-xs text-foreground-500 mt-1">{ev.weekday} {ev.time}</div>
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="text-sm md:text-base font-medium text-foreground-950">{ev.title}</h3>
                    <p className="text-xs md:text-sm text-foreground-500 mt-1">地点：{ev.place}</p>
                  </div>
                  <span className="shrink-0 inline-flex items-center px-3 py-1 rounded-full bg-background-100 border border-background-200 text-[11px] text-foreground-600 whitespace-nowrap">
                    {ev.tag}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}